export default __webpack_public_path__ + "static/media/whatsappIcon.9567a488.svg";